<template>
  <z-card
    size="large"
    class="lead-collector-section"
  >
    <LeadCollectorForm />
  </z-card>
</template>

<script>
import LeadCollectorForm from './lead-collector-form'
import messages from './i18n/lead-collector-section.json'

export default {
  name: 'LeadCollectorSection',
  components: {
    LeadCollectorForm,
  },
  data () {
    return {
      email: '',
      name: '',
      step: 'initial',
      formDisabled: false,
    }
  },
  i18n: {
    messages: {
      'pt-BR': messages,
    },
  },
}
</script>

<style lang="scss">
.lead-collector-section {
  margin-bottom: var(--unit-0100);
  margin-top: var(--unit-0100);
  width: 100%;

  @media (min-width: $breakpoint-desktop) {
    min-width: 248px;
  }
}
</style>
